'use client';
import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * Decide whether or not to allow sticky Column.
   * @default false
   */ sticky: PropTypes.bool
};
/**
 * @subcomponent Grid
 */ const Row = createComponent({
    displayName: 'Row',
    root: 'div',
    propTypes,
    propConfig: {
        classNames ({ sticky = false }) {
            return [
                'swan-row',
                sticky ? 'swan-row-sticky' : ''
            ];
        }
    }
});

export { Row };
